/* eslint-disable no-useless-escape */
/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable prettier/prettier */
import * as React from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { Client } from "@microsoft/microsoft-graph-client";
import { configs } from "./Configs";
import MyTree2 from "./MyTree2";
import { PrimaryButton, Spinner, SpinnerSize } from "@fluentui/react";
import axios from 'axios';

interface AppProps {
  title: string;
  userEmail: string;
}
interface AppState {
  token: string;
  client: Client;
}

export class App extends React.Component<AppProps, AppState> {

  constructor(props: AppProps) {
    super(props);
    this.silentRequest.loginHint = this.props.userEmail;
    this.state = { client: null, token: '' };
  }
  private loginDialog: Office.Dialog;
  private client: Client;
  private accessToken: any;

  private msalInstance = new PublicClientApplication({
    auth: {
      clientId: configs.ClientID,    //'2aedbe92-5dd4-48a7-95d8-9503965bff3a',
      authority: configs.Authority,// 'https://login.microsoftonline.com/common',
      redirectUri: configs.CurrentIsProd ? configs.RedirectProdDevURI : configs.RedirectDevURI// 'https://localhost:3000/login.html'
      //    redirectUri: 'https://otosp.z6.web.core.windows.net/login.html' 
    },
    cache: {
      cacheLocation: 'localStorage', // needed to avoid "login required" error
      storeAuthStateInCookie: false   // recommended to avoid certain IE/Edge issues
    }
  });

  private silentRequest = {
    scopes: [
      "openid",
      "user.read",
      "profile",
      "email",
      "User.Read.All",
      "User.ReadWrite.All",
      "Mail.Read",
      "Mail.ReadBasic",
      "Mail.ReadWrite",
      "Team.ReadBasic.All",
      "TeamSettings.Read.All",
      "TeamSettings.ReadWrite.All",
      "TeamworkTag.Read",
      "TeamworkTag.ReadWrite",
      "Group.Read.All",
      "Channel.ReadBasic.All",
      "ChannelSettings.Read.All",
      "Directory.Read.All",
      "Directory.ReadWrite.All",
      "Sites.Read.All",
      "Sites.ReadWrite.All",
      "Chat.Create",
      "Chat.ReadWrite.All",
      "Files.ReadWrite",
      "Files.ReadWrite.All",
      "TeamMember.Read.All",
      "TeamMember.ReadWrite.All"
    ],
    loginHint: Office.context.mailbox.userProfile.emailAddress// "none"
  };

  componentDidMount(): void {
    const initializeMsal = async () => {
      await this.msalInstance.initialize();
    };
    initializeMsal()
      .then(() => {
        this.msalInstance.ssoSilent(this.silentRequest)
          .then((data) => {
            this.client = Client.init({
              defaultVersion: "v1.0",
              debugLogging: true,
              authProvider: async (done) => {
                this.accessToken = data.accessToken;
                // console.log('Token=', data.accessToken);
                done("ddd", data.accessToken);
              },
            });
            this.setState({ client: this.client, token: data.accessToken });
          }).catch((error) => {
            console.log('error from ssoSlient', error);
            //   console.log(configs.CurrentIsProd ? configs.RedirectProdDevURI : configs.RedirectDevURI);
            Office.context.ui.displayDialogAsync(configs.CurrentIsProd ? configs.RedirectProdDevURI : configs.RedirectDevURI, { height: 65, width: 24 }, (result) => {
              if (result.status === Office.AsyncResultStatus.Failed) {
                console.log("result ", `${result.error.code} ${result.error.message}`);
              } else {
                const processLoginMessage = (arg: { message: string, origin: string }) => {
                  let messageFromDialog = JSON.parse(arg.message);
                  if (messageFromDialog.status === 'success') {
                    this.loginDialog.close();
                    console.log(messageFromDialog.result);
                    this.client = Client.init({
                      defaultVersion: "v1.0",
                      debugLogging: true,
                      authProvider: async (done) => {
                        this.accessToken = messageFromDialog.result;
                        //  console.log('Token=', this.accessToken);
                        done("ddd", messageFromDialog.result);
                      },
                    });
                    this.setState({ client: this.client, token: messageFromDialog.result });
                  }
                  else { this.loginDialog.close(); }
                };

                const processLoginDialogEvent = (arg) => {
                  console.log(arg);
                };
                this.loginDialog = result.value;
                this.loginDialog.addEventHandler(Office.EventType.DialogMessageReceived, processLoginMessage);
                this.loginDialog.addEventHandler(Office.EventType.DialogEventReceived, processLoginDialogEvent);
              }
            });
          });
      });

  }

  render(): React.ReactNode {

    return (
      <div style={{ height: "100vh", width: '100%', backgroundColor: "white", display: "flex", flexDirection: "column" }}>
        <div style={{ flex: "1 0 auto" }} id='main'  >
          {this.client == undefined &&
            <Spinner size={SpinnerSize.large} styles={{ root: { paddingTop: 50 } }} label="Loading...." />
          }
          {this.client !== null && this.client !== undefined && //this.state.getit &&
            <MyTree2 client={this.client} oContext={Office.context} token={this.state.token} />
          }

        </div>
        {/* <div style={{ textAlign: 'left', border: 'inset 1px black', width: '100%', alignSelf: 'flex-end', height: 30 }}>this is an error message</div> */}
        <div id='logo' style={{ alignSelf: "flex-end", paddingTop: 20 }}>
          <span style={{ fontSize: '8px' }}>{configs.Version}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <a href='http://www.meta-365.com' style={{ textDecoration: 'none' }}> <img src={require('../../../assets/logo_META365_vertical64.png')} alt="Logo" /></a>
        </div>

      </div>
    );
  }
};


export default App;
